// src/components/GenericHero.js
export default function GenericHero({ title, subtitle }) {
  return (
    <div
      className="py-12 starry-bg"
      style={{
        background:   'var(--bg-void)',
        borderBottom: '3px solid var(--brand-green)',
        position:     'relative',
      }}
    >
      <div className="section-container relative z-10">
        <div className="section-header" style={{ marginBottom: '12px' }}>
          Busitema University · Space Weather Project
        </div>

        <h1
          className="font-black"
          style={{
            fontSize: 'clamp(1.6rem, 4vw, 2.75rem)',
            color:    'var(--text-primary)',
            margin:   0,
          }}
        >
          {title}
        </h1>

        {subtitle && (
          <p
            style={{
              fontSize:   'clamp(0.95rem, 2vw, 1.1rem)',
              maxWidth:   '600px',
              color:      'var(--text-secondary)',
              marginTop:  '12px',
              lineHeight: 1.7,
            }}
          >
            {subtitle}
          </p>
        )}

        <div
          style={{
            width:        '60px',
            height:       '4px',
            background:   'linear-gradient(90deg, var(--brand-green), var(--brand-yellow))',
            borderRadius: '2px',
            marginTop:    '20px',
          }}
        />
      </div>
    </div>
  );
}
